var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noDocumentRequests
    ? _c(
        "no-results",
        {
          staticClass: "py-5",
          attrs: {
            "img-src": require("@Shared/@Assets/img/application-missing.png"),
          },
        },
        [
          _vm._v(
            "\n  " +
              _vm._s(_vm.$t("documents.thereAreNoDocumentTypesToShowYet")) +
              " "
          ),
          _c("br"),
          _vm._v(
            "\n  " +
              _vm._s(_vm.$t("documents.pleaseUseTheDocumentTypeDropdown")) +
              "\n"
          ),
        ]
      )
    : _c(
        "draggable",
        {
          staticClass: "row sortable-collapse",
          attrs: {
            id: "modal-document-list-container",
            tag: "div",
            animation: 200,
            "ghost-class": "ghost",
            handle: ".collapse-handle",
          },
          model: {
            value: _vm.orderedDocumentRequests,
            callback: function ($$v) {
              _vm.orderedDocumentRequests = $$v
            },
            expression: "orderedDocumentRequests",
          },
        },
        _vm._l(_vm.orderedDocumentRequests, function (documentRequest) {
          return _c(
            "b-col",
            {
              key: documentRequest.id,
              staticClass: "sortable-document",
              attrs: { cols: "12" },
            },
            [
              _c(
                "div",
                { staticClass: "sortable-row" },
                [
                  _c("document-request-list-collapse", {
                    attrs: {
                      "document-request": documentRequest,
                      "document-request-list-name": _vm.documentRequestListName,
                      "application-id": _vm.applicationId,
                      "client-username": _vm.clientUsername,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }